/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-in-app.html.twig';
import './dvsn-form-builder-in-app.scss';

const { Component } = Shopware;

Component.register('dvsn-form-builder-in-app', {
    template,

    inject: [
        'dvsnFormBuilderInAppService'
    ],

    props: {
        count: {
            type: Number,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            showInAppModal: false,
            showStatisticsModal: false,
        };
    },

    computed: {
        plans() {
            return this.dvsnFormBuilderInAppService.getPlans();
        },

        activePlan() {
            return this.dvsnFormBuilderInAppService.getActivePlan();
        },

        statisticsVariant() {
            return (this.isCritical()) ? 'critical' : 'secondary';
        },

        inAppVariant() {
            return (this.isCritical()) ? 'primary' : 'secondary';
        },

        statisticsButton() {
            if (this.isLoading === true) {
                return ''
            }

            if (this.activePlan !== null && this.activePlan.value === null) {
                return '';
            }

            return this.count + ' ' + this.$t('dvsn-form-builder.in-app.button.statistics.from') + ' ' + this.dvsnFormBuilderInAppService.getMax() + ' ' + this.$t('dvsn-form-builder.in-app.button.statistics.forms');
        }
    },

    methods: {
        isCritical() {
            if (this.isLoading === true) {
                return false;
            }

            return this.dvsnFormBuilderInAppService.isPlanLimitReached(this.count);
        },

        buttonIsDisabled(plan) {
            const activePlan = this.activePlan;

            if (plan.key === 'none') {
                return true;
            }

            if (activePlan === null) {
                return false;
            }

            if (this.plans[this.activePlan].value === null) {
                return true;
            }

            if (plan.value === null) {
                return false;
            }

            if (this.plans[this.activePlan].value > plan.value) {
                return true;
            }

            return false;
        },

        openInAppPurchaseModal() {
            this.showInAppModal = true;
        },

        closeInAppPurchaseModal() {
            this.showInAppModal = false;
        },

        openStatisticsModal() {
            this.showStatisticsModal = true;
        },

        closeStatisticsModal() {
            this.showStatisticsModal = false;
        },

        openInAppPurchase(plan) {
            this.showInAppModal = false;

            return this.dvsnFormBuilderInAppService.requestCheckout(plan);
        },
    },

    created() {
    }
});
